export const crmMessageScheduleConditionType = {
  lastReservationCreatedAt: "最後の予約申し込み日",
  lastReservationEndDate: "帰国日",
  lastQuestionConditionCreatedAt: "最後の旅行相談日",
  lastMessageCreatedAt: "最後にメッセージを送ってきた日",
  createdAt: "友だち追加日",
  lineType: "LINEタイプ",
};
